import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import VVButton from "../../../components/buttons/vv-button";
import EmailInput from "../../../components/form/email-input";
import Logo from "../../../components/logo/logo";
import { FormFunctions, useForm } from "../../../shared/hooks/use-form.hook";
import { forgetPasswordEmailApi } from "../apis/auth.api";
import ErrorMessage from "../components/error-message";
import { ForgotPasswordEmailEntity } from "../entities/forgot-password-email.entity";
import { ForgotPasswordEmailModel } from "../models/forgot-password-email.model";

export default function ForgotPasswordEmailPage() {
  const navigate = useNavigate();
  const [errorMessage, setErrorMessge] = useState(null);

  const handleSubmit = (e: any) => {
    e.preventDefault();
    forgetPasswordEmailApi(ForgotPasswordEmailModel.fromEntity(formFunc.values))
      .then((res) => {
        navigate(`/forgot-password-reset?email=${formFunc.values.email}`);
      })
      .catch((e) => {
        setErrorMessge(e.response.data.message);
      });
  };

  const formFunc: FormFunctions<ForgotPasswordEmailEntity> = useForm(
    handleSubmit,
    {
      email: "",
    }
  );

  return (
    <div className="flex min-h-full flex-col justify-center py-12 sm:px-6 lg:px-8">
      <div className="sm:mx-auto sm:w-full sm:max-w-md">
        <Logo />

        <h2 className="mt-6 text-center text-3xl font-bold tracking-tight text-gray-900">
          Please enter your email
        </h2>
        <p className="mt-2 text-center text-sm text-gray-600">
          Or{" "}
          <Link
            to="/login"
            className="font-medium text-indigo-600 hover:text-indigo-500"
          >
            Sign In
          </Link>
        </p>
      </div>

      <div className="mt-8 sm:mx-auto sm:w-full sm:max-w-md">
        <div className="bg-white py-8 px-4 shadow sm:rounded-lg sm:px-10">
          {errorMessage && (
            <div className="py-2">
              <ErrorMessage message={errorMessage} />
            </div>
          )}
          <form
            className="space-y-6 flex flex-col"
            action="#"
            method="POST"
            onSubmit={handleSubmit}
          >
            <EmailInput
              id="email"
              label="Email address"
              required
              value={formFunc.values.email}
              onChange={formFunc.onChange}
            />

            <VVButton
              type="submit"
              className="bg-indigo-600 self-center text-white"
            >
              Submit
            </VVButton>
          </form>
        </div>
      </div>
    </div>
  );
}
